import { DownloadFile, enqueueSnackbar, UploadFile, UploadFiles, FetchDownloads } from 'actions';
import {
	GetClustersNamesRequest,
	GenerateReportRequest,
	GetClusterDetailsRequest,
	GetSuperClustersRequest
} from '../requests/ReportsKpisRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_CLUSTERS_NAMES = 'GET_CLUSTERS_NAMES';
export const GET_CLUSTERS_DETAILS = 'GET_CLUSTERS_DETAILS';
export const GET_SUPER_CLUSTERS = 'GET_SUPER_CLUSTERS';

const onSetFormState = value => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS
});

const onGetClustersNames = value => ({
	type: GET_CLUSTERS_NAMES,
	clustersNames: value
});

const onGetSuperClusters = value => ({
	type: GET_SUPER_CLUSTERS,
	superClusters: value
});

const onGetClusterDetails = value => ({
	type: GET_CLUSTERS_DETAILS,
	clusterDetails: value
});

export const SetFormState = value => dispatch => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => dispatch => {
	dispatch(onResetFields());
};

export const GetClustersNames = (userId, host) => async dispatch => {
	await GetClustersNamesRequest(userId, host)
		.then(response => {
			dispatch(onGetClustersNames(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetSuperClusters = (userId) => async dispatch => {
	await GetSuperClustersRequest(userId)
		.then(response => {
			dispatch(onGetSuperClusters(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetClusterDetails = (userId, clusterName, host) => async dispatch => {
	await GetClusterDetailsRequest(userId, clusterName, host)
		.then(response => {
			dispatch(onGetClusterDetails(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GenerateReport = (userId, searchType, clusterName, host, type, numberOfDays, mocnActivationDateA, benefit, exportCellsDetails, exportTopOffendersDetails) => async dispatch => {
	await GenerateReportRequest(userId, searchType, clusterName, host, type, numberOfDays, mocnActivationDateA, benefit, exportCellsDetails, exportTopOffendersDetails)
		.then(response => {
			dispatch(FetchDownloads(userId, 'ReportKpis'));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

